import { type RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  projectDataDownload: "Analytics.AnalyticsProjectDataDownload",
  billingDetailDownload: "Analytics.AnalyticsBillingDetailDownload",
};

export { names as analyticsRouteNames };

const quickBooksRoutes: RouterOptions["routes"] = [
  {
    path: "/analytics",
    component: () => import("@/views/analytics/AnalyticsBase.vue"),
    children: [
      {
        path: "downloadProjectData",
        name: names.projectDataDownload,
        meta: { title: "Project Data Download", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsProjectDataDownload.vue"),
      },
      {
        path: "downloadBillingDetails",
        name: names.billingDetailDownload,
        meta: { title: "Billing Detail Download", hideFilterChange: true },
        component: () => import("@/views/analytics/AnalyticsBillingDetailDownload.vue"),
      },
    ],
  },
];
export default quickBooksRoutes;
